import { useCallback } from 'react'
import PropTypes from 'prop-types'
import { useDropzone } from 'react-dropzone'

import DialogBody from 'components/Dialog/DialogBody'
import DialogTitle from 'components/Dialog/DialogTitle'
import DialogActions from 'components/Dialog/DialogActions'

import uploadFileUtils from 'components/PosAccounts/utils/uploadFile'
import { UPLOAD_ORG_ATTENDANTS_STEPS } from 'resources'
import { ReactComponent as CloseIcon } from 'assets/icons/closeIcon.svg'

const UploadFile = ({
  setStep,
  setFile,
  isFile,
  handleUploadDialogClose,
}) => {
  const onDrop = useCallback(
    (acceptedFiles, fileRejections) => {
      uploadFileUtils.handleUploadFile(
        acceptedFiles,
        fileRejections,
        setFile,
        setStep
      )
    },
    [setStep, setFile]
  )

  const { getRootProps, getInputProps } = useDropzone({
    maxFiles: 1,
    accept: {
      'text/csv': ['.csv'],
    },
    onDrop,
  })

  return (
    <>
      <DialogTitle>
        <header className="upload-file__header">
          <h3 className="upload-file__title">
            Upload Organization Attendants
          </h3>
          <button
            type="button"
            className="upload-file__close-dialog-icon"
            onClick={handleUploadDialogClose}
          >
            <CloseIcon />
          </button>
        </header>
      </DialogTitle>
      <DialogBody classNames="font-size-middle">
        <span>
          Upload your <span className="font-weight-bold">CSV</span>{' '}
          file here. Please make sure you are using the template
          provided below.
        </span>
        <div
          {...getRootProps({
            className: 'upload-file__dropzone',
          })}
        >
          <span className="upload-file__header">
            Drag and Drop file here
          </span>
          <span className="upload-file__description">
            Files Supported: CSV
          </span>
          <span className="upload-file__choose-file-button">
            Choose File
          </span>
          <a
            href="files/AttendantsUploadTemplate.csv"
            className="upload-file__download-button"
            onClick={(e) => e.stopPropagation()}
          >
            Download Template
          </a>
          <input {...getInputProps()} />
        </div>
      </DialogBody>
      <DialogActions>
        <div className="upload-file__actions">
          <button
            type="button"
            onClick={() =>
              setStep(UPLOAD_ORG_ATTENDANTS_STEPS.UPLOADED_FILE)
            }
            className="upload-file__button"
            disabled={!isFile}
          >
            Next
          </button>
        </div>
      </DialogActions>
    </>
  )
}

UploadFile.propTypes = {
  setStep: PropTypes.func,
  setFile: PropTypes.func,
  isFile: PropTypes.bool,
  handleUploadDialogClose: PropTypes.func,
}

export default UploadFile
